import React from 'react';
import PropTypes from 'prop-types';
import { Container } from 'reactstrap';

import PreviewGenerationStatus from './PreviewGenerationStatus';

function PreviewGenerationFallback({ progress = 0 }) {
    return (
        <div className="preview-lux preview-lux--generating" data-testid="conversation-preview">
            <Container className="preview-page">
                <PreviewGenerationStatus progress={progress} />
            </Container>
        </div>
    );
}

PreviewGenerationFallback.propTypes = {
    progress: PropTypes.number,
};

export default PreviewGenerationFallback;

export function isConversationPreviewPath(pathname = '') {
    return /\/conversation\/[^/]+(\/(preview|start))?\/?$/.test(pathname);
}
